"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var debug_1 = __importDefault(require("../../lib/debug"));
var JSONSignedCertificate_1 = __importDefault(require("../../lib/JSONSignedCertificate"));
var AbstractAuthorityClient_1 = __importDefault(require("../AbstractAuthorityClient"));
var debug = debug_1.default.extend('axios-client');
/**
 * This class is a sample implementation of the AuthorityClient, using an axios
 * instance, and expecting the server to run the express-router defined in this
 * same folder.
 *
 * The axios instance is expected to handle the authentication part and add what
 * is needed to convey the user's identity to the server.
 *
 * The issuer must be explicitly specify if it doesn't match the baseURL
 * configured on the axios instance.
 *
 * The baseURL must point to the express-router's base path.
 */
var HTTPClient = /** @class */ (function (_super) {
    __extends(HTTPClient, _super);
    function HTTPClient(axios, issuer) {
        if (issuer === void 0) { issuer = null; }
        var _this = _super.call(this, issuer || axios.defaults.baseURL || '') || this;
        if (!_this.issuer) {
            debug({ action: 'constructor', axios: axios, issuer: issuer });
            throw new Error('Invalid issuer');
        }
        _this.axios = axios;
        return _this;
    }
    // we retrieve all public key at once with this call, removing the need to
    // use the provided keyid
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    HTTPClient.prototype.getPublicKey = function (keyid) {
        return __awaiter(this, void 0, void 0, function () {
            var res, err_1, data, k;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        debug({ action: 'getPublicKey', keyid: keyid });
                        res = null;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.axios.get('/pub/keys')];
                    case 2:
                        res = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        debug({ action: 'getPublicKey-http-error', err: err_1 });
                        return [2 /*return*/, null];
                    case 4:
                        data = [];
                        for (k in res.data)
                            data.push({
                                keyid: k,
                                data: res.data[k],
                            });
                        debug({ action: 'getPublicKey', result: data });
                        return [2 /*return*/, data];
                }
            });
        });
    };
    HTTPClient.prototype.sendCertificateRequest = function (jcr_encoded) {
        return __awaiter(this, void 0, void 0, function () {
            var res, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        debug({ action: 'sendCertificateRequest', jcr_encoded: jcr_encoded });
                        res = null;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.axios.post('/idt/cert', {
                                jcr: jcr_encoded,
                            })];
                    case 2:
                        res = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_2 = _a.sent();
                        debug({ action: 'sendCertificateRequest', err: err_2 });
                        throw err_2;
                    case 4:
                        debug({ action: 'sendCertificateRequest', result: res.data.jsc });
                        return [2 /*return*/, new JSONSignedCertificate_1.default(res.data.jsc)];
                }
            });
        });
    };
    HTTPClient.prototype.sendCertificateRevokationRequest = function (certificate_id) {
        return __awaiter(this, void 0, void 0, function () {
            var res, err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.axios.delete('/idt/cert/' + certificate_id)];
                    case 1:
                        res = _a.sent();
                        debug({
                            action: 'sendCertificateRevokationRequest',
                            certificate_id: certificate_id,
                            success: res.data.success,
                        });
                        return [2 /*return*/, res.data.success];
                    case 2:
                        err_3 = _a.sent();
                        debug({ action: 'sendCertificateRevokationRequest', err: err_3, certificate_id: certificate_id });
                        return [2 /*return*/, false];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    HTTPClient.prototype.getRevokedCertificates = function (last_update) {
        return __awaiter(this, void 0, void 0, function () {
            var headers, res, err_4;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        headers = {};
                        if (last_update) {
                            headers['if-modified-since'] = new Date(last_update).toUTCString();
                        }
                        debug({ action: 'getRevokedCertificates', last_update: last_update, headers: headers });
                        res = null;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.axios.get('/pub/revoked', { headers: headers })];
                    case 2:
                        res = _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_4 = _b.sent();
                        if ((err_4 === null || err_4 === void 0 ? void 0 : err_4.isAxiosError) === true && ((_a = err_4.response) === null || _a === void 0 ? void 0 : _a.status) === 304) {
                            return [2 /*return*/, null];
                        }
                        debug({ action: 'getRevokedCertificates', err: err_4 });
                        throw err_4;
                    case 4: return [2 /*return*/, res.data];
                }
            });
        });
    };
    HTTPClient.prototype.getOwnCertificateList = function () {
        return __awaiter(this, void 0, void 0, function () {
            var res, err_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        debug({ action: 'getOwnCertificateList' });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.axios.get('/idt/cert')];
                    case 2:
                        res = _a.sent();
                        return [2 /*return*/, res.data];
                    case 3:
                        err_5 = _a.sent();
                        debug({ action: 'getOwnCertificateList', err: err_5 });
                        throw err_5;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return HTTPClient;
}(AbstractAuthorityClient_1.default));
exports.default = HTTPClient;
